import { render } from "./PurchasingReport.vue?vue&type=template&id=438cd624&ts=true"
import script from "./PurchasingReport.vue?vue&type=script&lang=ts"
export * from "./PurchasingReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__